'use client';

import Link from 'next/link';
import { forwardRef, type ComponentProps } from 'react';
import { isLoginHref, requestLogin } from '@/lib/auth/login-dialog';

/** A normal link retains no-JS/new-tab behavior; ordinary activation opens sign-in in place. */
const LoginLink = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(function LoginLink(
  { href, onClick, target, ...props }, ref,
) {
  let path: string;
  if (typeof href === 'string') path = href;
  else {
    const query = new URLSearchParams();
    if (typeof href.query !== 'string') for (const [key, value] of Object.entries(href.query ?? {})) {
      if (Array.isArray(value)) value.forEach((item) => query.append(key, String(item)));
      else if (value !== undefined && value !== null) query.set(key, String(value));
    }
    const search = href.search ?? (typeof href.query === 'string' ? `?${href.query}` : query.size ? `?${query}` : '');
    path = href.host || href.hostname || href.protocol ? '' : `${href.pathname ?? ''}${search}${href.hash ?? ''}`;
  }
  return <Link {...props} ref={ref} href={href} target={target} onClick={(event) => {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (target && target !== '_self') || props.download !== undefined || !isLoginHref(path)) return;
    event.preventDefault();
    requestLogin(path);
  }} />;
});

export default LoginLink;
